import { ApiProperty } from "@nestjs/swagger";
import { LogBookItems } from "../../log-book-items/log-book-items.entity";

export class ContainerLogBookDto {
    @ApiProperty()
    containerLogBookId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    brandId: number;
    @ApiProperty()
    containerNo: string;
    @ApiProperty()
    vehicleNo:string;
    @ApiProperty()
    loadingStartTime: string;
    @ApiProperty()
    loadingEndTime: string;  
    @ApiProperty()
    loadingDate: Date;
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    fileName: string;
    @ApiProperty()
    filePath: string;
    @ApiProperty()
    isActive:boolean;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string;
    @ApiProperty()
    versionFlag: number;
    @ApiProperty({ type: [LogBookItems]})
    LogBookInfo: LogBookItems[];
}